import React from "react";

const LOGO_URL = "/cps-logo.png";

export const Logo = ({ className = "", textColor = "text-slate-700", subColor = "text-slate-500" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div className="relative h-11 w-11">
        <img
          src={LOGO_URL}
          alt="CPS Consulting logo"
          className="h-full w-full object-contain"
          loading="eager"
        />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display text-[15px] font-bold tracking-[0.18em] ${textColor}`}>
          CPS
        </span>
        <span className={`text-[10px] font-medium tracking-[0.32em] ${subColor}`}>
          CONSULTING
        </span>
      </div>
    </div>
  );
};

export default Logo;
